/**
 * @author
 * @file radioGroup
 * @author (zhaomiaoyuan)
 */
import RadioGroup from './RadioGroup';
import Radio from './Radio.js';
export { Radio };
export default RadioGroup;